import { useLang } from "@/i18n/LanguageContext";

/** Subtle ES | EN switch. Preserves diagnostic answers (state is language-independent). */
export const LanguageToggle = () => {
  const { lang, setLang } = useLang();
  const base = "text-xs tracking-[0.18em] transition-colors px-1";
  return (
    <div className="flex items-center gap-1" data-testid="language-toggle">
      <button
        onClick={() => setLang("es")}
        data-testid="lang-es"
        aria-pressed={lang === "es"}
        className={`${base} ${lang === "es" ? "text-[#0B0E14] font-semibold" : "text-[#A0AEC0] hover:text-[#4A5568]"}`}
      >
        ES
      </button>
      <span className="text-[#CBD2D9] text-xs">|</span>
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        className={`${base} ${lang === "en" ? "text-[#0B0E14] font-semibold" : "text-[#A0AEC0] hover:text-[#4A5568]"}`}
      >
        EN
      </button>
    </div>
  );
};
